import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
    ar: {
        loadMore: 'تحميل المزيد',
        AppointmentRequests: "طلبات تعيين",
        UpgradeRequests: "طلبات ترقية",
        noNews: "لا يوجد اخبار",
        noMembers: "لا يوجد اعضاء",
        noNotifications: "لا يوجد اشعارات",
        submitButton: 'تأكيد',
        //Login
        logintitle: "تسجيل الدخول",
        codeErr: "الرمز غير صحيح",
        forgetPass: "نسيت كلمة المرور",
        noAccount: "ليس لديك حساب-",
        signup: "الاشتراك",
        backlogin: 'الرجوع الي التسجيل ؟',
        acceptSignup: "اوافق على كل ",
        upgrade: "شروط الترقية",
        acceptErr: "يجب الموافقة على شروط الترقية",
        forgetTitle: 'اكتب بريدك الالكتروني المسجل به لاعادة كلمة المرور',
        resetPass: 'اعادة تعيين كلمة المرور',
        codeTitle: 'ادخل الكود المرسل على البريد الالكتروني',
        // Layout
        home: "الرئيسية",
        about: "من نحن",
        administration: "الادارات",
        faculties: "الكليات",
        deanships: "العمادات",
        centers: "المراكز",
        employment: "التوظيف",
        contactUs: "اتصل بنا",
        magazineUni: "مجلة الجامعة",
        logoutBTN: "تسجيل الخروج",

        // SideMenu
        vice: " كلمة وكيل الجامعه للدراسات العليا",
        vision: " الرؤيه و الرساله و الاهداف",
        administrationMember: " منسوبي الاداره",
        publicationRule: "قواعد النشر",
        regulation: "اللوائح و الانظمه",
        completeIssues: "أعداد المجلة الكاملة",
        privateIssues: "أعداد المجلة الخاصة",
        editorialBoard: " هيئه التحرير",
        forms: "النماذج",
        news: "الاخبار",
        mailing: "المراسلات",
        // Footer
        Rights: "جميع الحقوق محفوظه - جامعه جازان  2019",
        email: "البريد الالكتروني",
        emailHint: "اكتب بريدك الالكتروني ليصلك كل كل اخبار المجلة الحصرية",
        Departments: "الاقسام",

        // AllPublishingRequests
        publishingRequests: 'طلبات النشر',
        NoPublishingRequests: "لا يوجد طلبات النشر",
        noforms:"لايوجد نماذج",
        preview: 'معاينه',
        publication_confirm: "تم إرسال طلبكم",
        // PublishingRequests details
        sendRequest: 'ارسال الطلب',
        reviewAttach: 'مراجعه المرفقات',
        judge: 'اسناد الي المحكم',
        results: 'النتائج',
        senddone: 'تم ارسال الطلب',
        attachDone: 'تم مراجعه و قبول المرفقات من خلال الأستاذ  ',
        manageDone1: 'تم الموافقه على الطلب من ',
        manageDone2: 'من خلال ',
        judgeDone1: "تم اسناد الطلب الي المحكم   ",
        judgeDone2: "و في انتظار القبول او الرفض",
        accepted: "تم القبول من خلال ",
        rejected: "تم الرفض من قبل ",

        //promotion
        promotionrequest: "طلب ترقية",
        models: "النماذج",
        uploadfiles: "تحميل الملفات",
        publicationreq: "طلب نشر",
        send: "إرسال",
        filevalidation: "يجب تحميل ملف",

        //profile setting
        profilesetting: "اعدادات الحساب",
        save: "حفظ التعديلات",
        editimg: "تعديل الصورة",
        editinfo: "تم حفظ التعديلات",
        backtohome: "العوده الي الرئيسية",

        // Magazine
        fullNumbers: "لتصفح الاعداد الكاملة",
        specialNumbers: "لتصفح الاعداد الخاصة",
        judgementWanted: "هل تريد ان تصبح محكما ",

        // VOLUMES
        FullVolumes: 'الاعداد الكاملة',
        SpecialVolumes: 'الاعداد الخاصة',
        category: 'فرع',
        volume: 'العدد',
        // About Us
        editorialBoardHead: "كلمة رئيس هيئه التحرير",
        viceRectorWord: " كلمة وكيل الجامعة للدراسات العليا والبحث العلمي",
        AboutUs: "نبذه عن الاداره",
        //forms
        formstitle: "النماذج"

    },
    en: {
        //forms
        formstitle: "Forms",

        noNews: "There are not News",
        //profile setting
        backtohome: "Home Page",
        editinfo: "Edits Saved",
        editimg: "Edit Image",
        profilesetting: "Profile Setting",
        save: "Save",
        noMembers: "There are not Members",
        noNotifications: "There are not Notifications",
        //promotion
        filevalidation: "Please Upload File",
        send: "Send",
        publicationreq: "Publication Request",
        models: "Models",
        uploadfiles: "Upload Files ",
        promotionrequest: "Promotion Request",
        loadMore: 'Load more',

        AppointmentRequests: "Appointment Requests",
        UpgradeRequests: "Upgrade Requests",
        submitButton: "Confirm",
        //Login
        logintitle: "Login",
        codeErr: "incorrect code",
        forgetPass: "Forgot password",
        noAccount: "You don't have account - ",
        signup: "Signup",
        backlogin: 'Back to login ?',
        acceptSignup: "I accept all",
        upgrade: "upgrade terms",
        acceptErr: "Upgrade terms must be approved",
        forgetTitle: 'Type your email address to reset your password',
        resetPass: 'Password reset',
        codeTitle: 'Enter code sent in your email',

        // Layout
        home: "Home",
        about: "About",
        administration: "Administration",
        faculties: "Faculties",
        deanships: "DeanShips",
        centers: "Centers",
        employment: "Employment",
        contactUs: "Contact Us",
        magazineUni: "Magazine University",
        logoutBTN: "Logout",

        // SideMenu
        vice: "Vice Dean for Graduate Studies",
        vision: "Visions, Missions, Goals",
        administrationMember: "administration Members",
        publicationRule: "Publication Rules",
        regulation: "Regulations and System",
        completeIssues: "Complete Issues of Journal",
        privateIssues: "Private Issues of Journal",
        editorialBoard: "Editorial Board",
        forms: "Forms",
        news: "News",
        mailing: "Mailing",
        // Footer
        Rights: "All Rights Reserved - Jazan University 2019",
        email: "E-mail",
        emailHint: "Write your email to receive all the news of the magazine exclusive",
        Departments: "Departments",

        // AllPublishingRequests
        publishingRequests: 'Publishing requests',
        NoPublishingRequests: "There's no publishing requests",
        noforms:"there is no forms",
        preview: 'Preview',
        // PublishingRequests details
        sendRequest: 'Send request',
        reviewAttach: 'Review attachments',
        judge: 'Attributed to the judge',
        results: 'Results',
        publication_confirm: "Request is Sent",
        senddone: 'Request sent',
        attachDone: 'Attachments were reviewed and accepted by ',
        manageDone1: "The request from ",
        manageDone2: ' was approved by ',
        judgeDone1: "The application was assigned to the courts ",
        judgeDone2: "and is awaiting acceptance or rejection",
        accepted: "Accepted by ",
        rejected: "Rejected by ",


        fullNumbers: "Browse Full Volumes",
        specialNumbers: "Browse Special Volumes",
        judgementWanted: "Do you want be a Judgement",

        // VOLUMES
        FullVolumes: 'Full volumes',
        SpecialVolumes: 'Special volumes',
        category: 'category',
        volume: 'volume',
        // About Us
        editorialBoardHead: "Speech of Chief of the Editorial Board",
        viceRectorWord: "Vice Rector for Graduate Studies and Scientific Research",
        AboutUs: "Breif ON Administration"

    }

});

export default strings; 